/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {get1099IntStatements} from '../api'

 export const useQueryGet1099IntStatements = createReactQueryHook('get1099IntStatements', get1099IntStatements)
